<div class="modal-header pt-3 pb-2 px-3">
  @if (fileToMove || (isBulkMove && filesToMove && filesToMove.length > 0)) {
    <h2 class="modal-title">
      {{
        isBulkMove ? 'Move ' + filesToMove.length + ' Selected Items' : ('Move "' + fileToMove.name + '"' | titlecase)
      }}
    </h2>
  } @else {
    <h2 class="modal-title">Select a folder</h2>
  }
  <span class="ms-auto" (click)="activeModal.dismiss('Cross click')" role="button">
    <svg-icon [name]="'modal-close-menu'"></svg-icon>
  </span>
</div>
<div class="modal-body px-3 pt-0 pb-3 d-flex flex-column">
  @if (selectedDestination && folderPath.length > 0) {
    <div class="align-items-center d-flex mb-2">
      <i class="bi bi-arrow-left-circle cursor-pointer fs-20 me-1" (click)="navigateBack()"></i>
      <h6 class="fs-18 mb-0 ms-1 cursor-pointer">
        {{ selectedDestination.name | titlecase }}
      </h6>
    </div>
  }

  <div
    class="list-group mb-3 mh-400 overflow-y-auto flex-fill"
    [ngClass]="
      folderHierarchy.length === 0 ? 'd-flex flex-column justify-content-center bg-gray-200' : 'border-top rounded-0'
    "
  >
    @if (folderHierarchy && folderHierarchy.length > 0) {
      @for (item of folderHierarchy; track $index) {
        <div class="list-group-item border-0 p-0 rounded-2">
          <div
            class="d-flex align-items-center gap-2 p-2 cursor-pointer"
            [ngClass]="isItemDisabled(item) ? 'text-muted text-opacity-50' : ''"
            (click)="item.type === 'Folder' && !isItemDisabled(item) ? selectFolder(item) : null"
            [ngbTooltip]="getItemTooltip(item)"
            [disableTooltip]="item.type === 'Folder' && !isItemDisabled(item)"
          >
            <!-- Show appropriate icon based on file type -->
            @if (item.type === 'Folder') {
              <svg-icon name="ft-folder" class="svg-28"></svg-icon>
            } @else {
              <svg-icon name="ft-{{ item.name.split('.').pop() }}" class="svg-28"></svg-icon>
            }
            <span class="fs-16 fw-500">{{ item.name | titlecase }}</span>
          </div>
          @if (item.type === 'Folder' && !isItemDisabled(item)) {
            <i
              class="bi bi-chevron-right end-0 position-absolute top-50 translate-middle d-none arrow-move cursor-pointer"
            ></i>
          }
        </div>
      }
    } @else {
      <div class="d-flex flex-column fs-18 fw-500 p-3 rounded-2 text-center">
        <i class="bi bi-folder-x fs-40"></i>
        This folder is empty
      </div>
    }
  </div>

  <div class="d-flex align-items-center gap-1 flex-wrap">
    <i class="fs-20 cursor-pointer bi bi-house-door text-primary"></i>
    <h6 class="fs-18 mb-0 ms-1 cursor-pointer" (click)="navigateFolder(null)">All Folders</h6>
    <svg-icon name="chevron-right" class="svg-16"></svg-icon>
    @for (folder of folderPath; track $index) {
      <h6 class="cursor-pointer text-primary text-decoration-underline mb-0" (click)="navigateFolder(folder)">
        {{ folder.name | titlecase }}
      </h6>
      <svg-icon name="chevron-right" class="svg-16"></svg-icon>
    }
  </div>

  <!-- Permission warning -->
  @if (fileToMove || (isBulkMove && filesToMove && filesToMove.length > 0)) {
    <div class="alert alert-warning mt-3 mb-2 rounded-3">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-exclamation-triangle-fill me-2 fs-5 text-warning"></i>
        <span
          >When moving {{ isBulkMove ? 'these items' : 'this item' }}, {{ isBulkMove ? 'their' : 'its' }} current
          sharing permissions will be removed and the permissions of the destination folder will be applied.</span
        >
      </div>
    </div>
  }
</div>

<div class="modal-footer gap-2">
  <button type="button" class="btn btn-secondary btn-h45 m-0" (click)="activeModal.close()">Cancel</button>
  <button
    type="button"
    class="btn btn-primary btn-h45 m-0"
    [disabled]="nameConflictExists"
    (click)="selectFolderAndClose()"
  >
    @if (fileToMove || (isBulkMove && filesToMove && filesToMove.length > 0)) {
      Move {{ isBulkMove ? 'Items' : '' }}
    } @else {
      Select Folder
    }
  </button>
</div>
